module.exports = __webpack_public_path__ + "media/96.3d069870.mp3";